<template>
  <h1 class="title has-text-centered">
    <go-to-dashboard-button />

    {{ $t("credits.title") }}&nbsp;

    <button class="button" @click="$emit('get-credits')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <span v-if="permissions.cedeCashback">
      &nbsp;
      <button class="button" @click="$emit('give-credit')">
        <b-icon icon="plus-circle" type="is-primary"></b-icon>
      </button>
    </span>

    <!-- &nbsp;
    <button class="button">
      <b-icon icon="save"></b-icon>
    </button> -->

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common],

  components: {
    goToDashboardButton
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
